const getImageUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    // Treat bare CloudFront URLs (no file path) as empty
    if (url === 'http://localhost:4566/fitwith/' || url === 'https://cdn.withme.so/' || url === 'https://cdn-nightly.fitwithofficial.com/') return '';
    let __DEV__ = window.location.hostname === 'localhost';
    let newUrl = url;
    if (url.startsWith('null')) {
        newUrl = url.replace('null', __DEV__ ? 'http://localhost:4566/fitwith' : 'https://cdn.withme.so')
    } else if (!url.startsWith('http') && !url.startsWith('blob:') && !url.startsWith('data:')) {
        newUrl = (__DEV__ ? 'http://localhost:4566/fitwith/' : 'https://cdn.withme.so/') + url;
    }
    return newUrl
};

export default getImageUrl;